import KuikaModalIconWrapper from "./kuika-modal-icon-wrapper";

export default KuikaModalIconWrapper;
export type { IKuikaModalIconWrapperProps } from "./kuika-modal-icon-wrapper";
